import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { components } from 'react-select';
import kebabCase from 'lodash/kebabCase.js';
import PropTypes from 'prop-types';
import { MaterialCheckbox } from '../../../material/MaterialCheckbox.js';
import { FAIcon } from '../../fa-icon/component.js';
var Option = components.Option;
var SelectCheckboxOption = function SelectCheckboxOption(props) {
  var _selectProps$name$rep, _selectProps$name, _selectProps$name$rep2, _selectProps$options, _selectProps$options$, _selectProps$options$2;
  var isMulti = props.isMulti,
    isSelected = props.isSelected,
    label = props.label,
    multi = props.multi,
    selectProps = props.selectProps,
    useRightCheckmark = props.useRightCheckmark,
    helperText = props.helperText;
  var formattedName = (_selectProps$name$rep = selectProps === null || selectProps === undefined || (_selectProps$name = selectProps.name) === null || _selectProps$name === undefined || (_selectProps$name$rep2 = _selectProps$name.replace) === null || _selectProps$name$rep2 === undefined ? undefined : _selectProps$name$rep2.call(_selectProps$name, '[]', '')) !== null && _selectProps$name$rep !== undefined ? _selectProps$name$rep : '';
  var name = formattedName ? "-".concat(formattedName) : '';
  var optionIndex = selectProps === null || selectProps === undefined || (_selectProps$options = selectProps.options) === null || _selectProps$options === undefined || (_selectProps$options$ = _selectProps$options.map) === null || _selectProps$options$ === undefined || (_selectProps$options$ = _selectProps$options$.call(_selectProps$options, function (option) {
    return option === null || option === undefined ? undefined : option.label;
  })) === null || _selectProps$options$ === undefined || (_selectProps$options$2 = _selectProps$options$.indexOf) === null || _selectProps$options$2 === undefined ? undefined : _selectProps$options$2.call(_selectProps$options$, label);
  var dataAction = "select-option-".concat(kebabCase(label));
  var dataObjectId = "Select".concat(name, "-option-").concat(optionIndex);
  var multiSelect = isMulti || multi;
  var multiSelectCheckbox = function multiSelectCheckbox() {
    return /*#__PURE__*/React.createElement(MaterialCheckbox, _extends({
      helpLine: helperText,
      checked: isSelected
    }, props));
  };
  var singleSelectOption = function singleSelectOption() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, label, !!helperText && /*#__PURE__*/React.createElement("div", {
      className: "helper-text"
    }, helperText)), isSelected && useRightCheckmark && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        right: '15px',
        top: '20%'
      }
    }, /*#__PURE__*/React.createElement(FAIcon, {
      icon: "check"
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-action": dataAction,
    "data-object-id": dataObjectId,
    style: {
      position: 'relative'
    }
  }, multiSelect ? /*#__PURE__*/React.createElement(React.Fragment, null, multiSelectCheckbox(), " ") : /*#__PURE__*/React.createElement(Option, props, singleSelectOption()));
};
SelectCheckboxOption.displayName = "SelectCheckboxOption";
SelectCheckboxOption.propTypes = {
  helperText: PropTypes.string,
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  multi: PropTypes.bool,
  useRightCheckmark: PropTypes.bool,
  selectProps: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.array
  })
};
export { SelectCheckboxOption };